<template>
    <v-container fluid>
        <h4>{{ $t('metadata_for', { title: record.displayTitle }) }}</h4>
        <table class="stripe-table mt-2 tgk-paragraph-text">
            <tbody>
                <tr>
                    <td>{{ $t('rec_id') }}</td>
                    <td>
                        <span>{{ record.id }}</span> / UUID: <span>{{ record.uuid }}</span>
                    </td>
                </tr>
                <tr v-if="record.organizer_id">
                    <td>Event-Organizer-ID</td>
                    <td>
                        <span>{{ record.organizer_id }}</span> / UUID: <span>{{ record.organizer_uuid }}</span>
                    </td>
                </tr>
                <tr v-if="record.location_id">
                    <td>Location-ID</td>
                    <td>
                        <span>{{ record.location_id }}</span> / UUID: <span>{{ record.location_uuid }}</span>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('addr_typ') }}</td>
                    <td>
                        <span v-if="record.legal_type === 'person'"> {{ $t('person') }} </span>
                        <span v-if="record.legal_type === 'organization'"> {{ $t('organization') }} </span>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('created') }}</td>
                    <td>
                        {{ record.created.formatIf('dd, DD.MM.YYYY HH:mm') }}
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('creator') }}</td>
                    <td>
                        {{ record.creator }}
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('modified') }}</td>
                    <td>
                        {{ record.modified.formatIf('dd, DD.MM.YYYY HH:mm') }}
                        <span v-if="record.modifier"> / {{ record.modifier }}</span>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('import_protection') }}</td>
                    <td>
                        {{ record.import_protection ? $t('yes') : $t('no') }}
                    </td>
                </tr>
            </tbody>
        </table>
    </v-container>
</template>

<script>
import { Address } from '@/models/Address';

export default {
    name: 'AddressEditMetadata',
    props: {
        record: {
            type: Address,
            required: true,
        },
    },
};
</script>
